import src from "IMAGE";
export default { src, width: 476, height: 168, blurWidth: 0, blurHeight: 0};
